import { ApolloLink } from "@apollo/client";
import _ from "lodash";
import { DateTime } from "luxon";

export const convertDatesLink = new ApolloLink((operation, forward) => {
    if('intake' === operation.operationName) {
        return forward(operation);
    }
    operation.variables = convertDates(_.cloneDeep(operation.variables), (furtherRecursionNeeded: boolean, value: any) => {
        if(!furtherRecursionNeeded && /^\d{2}\/\d{2}\/\d{4}$/gi.test(value)) {
            return DateTime.fromFormat(value, "MM/dd/yyyy").toISODate()
        }
        return value;
    })
    return forward(operation).map((data) => {
        return convertDates(_.cloneDeep(data), (furtherRecursionNeeded: boolean, value: any) => {
            if(!furtherRecursionNeeded && /^\d{4}-\d{2}-\d{2}$/gi.test(value)) {
                return DateTime.fromISO(value).toFormat("MM/dd/yyyy")
            }
            return value;
        });
    });
});

const convertDates = (obj: any, conversionFunction: any) => _.transform(obj, (acc: any, value, key, target) => {
    const furtherRecursionNeeded = _.isObject(value) || _.isArray(value);
    const newValue = conversionFunction(furtherRecursionNeeded, value)
    acc[key] = furtherRecursionNeeded ? convertDates(newValue, conversionFunction) : newValue;
});